/**
 * Support Route
 * Help center and support resources page
 * Layout provided by _authenticated parent route
 * Authentication inherited from parent
 */

import { createFileRoute } from '@tanstack/react-router';
import { SupportPage } from '../../pages/Support/SupportPage';

/**
 * Support Route Component
 * Layout (MainLayout, Sidebar) provided by parent _authenticated route
 * Sessions panel automatically hidden for support route in parent
 */
const SupportRouteComponent = () => {
  return <SupportPage />;
};

/**
 * Route Configuration
 * Path: /_authenticated/support
 * - Authentication inherited from _authenticated parent (no requireAuth needed)
 * - MainLayout structure inherited from _authenticated parent
 * - Sessions panel hidden automatically (parent checks location.pathname)
 */
export const Route = createFileRoute('/_authenticated/support')({
  component: SupportRouteComponent,
});
